
import { defineComponent, PropType } from 'vue';
import Slider, { Options, Values } from './Slider.vue';
import { ClientConstants, Duration } from './../client.constants';

export default defineComponent({
  name: 'FractionalCdSliderComponent',
  components: { Slider },
  props: {
    id: { type: String, required: true },
    values: {
      type: Array as PropType<Options>,
      required: true,
      validator(obj: { key: number; leftValue: string | Duration; rightValue: string | Duration }) {
        return obj.key !== null && obj.leftValue !== null && obj.rightValue !== null;
      }
    },
    currentValue: { type: Number, default: 0, required: false },
    labelSize: { type: String, default: 'normal', required: false }
  },
  data: () => {
    return {
      clientConstants: ClientConstants,
      currentValueKey: 0
    };
  },
  computed: {
    /*
     * checks for the value in the values array passed in from the parent
     * returns the value if found, empty string if not
     */
    selectedValue(): string[] {
      const pair = this.values.find((obj: Values) => obj.key === this.currentValueKey);
      if (pair) {
        return pair.rightValue ? [pair.leftValue, pair.rightValue] : [pair.leftValue, ''];
      }
      return ['', ''];
    },
    sliderLabel(): string {
      return `${this.id}-label`;
    },
    leftSliderValue(): string {
      return `${this.id}-left-value`;
    },
    rightSliderValue(): string {
      return `${this.id}-right-value`;
    }
  },
  methods: {
    handleSliderValueChanged(value: string) {
      this.currentValueKey = Number(value);
    }
  },
  mounted() {
    this.currentValueKey = this.currentValue;
  }
});
